import React, { memo } from "react";

const UploadIcon = ({
  size = 16,
  className,
}: {
  size?: number;
  className?: string;
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 15"
    fill="none"
    className={className}
    aria-hidden
  >
    <path
      d="M12.75 9.16176V12.2206C12.75 13.0653 12.0784 13.75 11.25 13.75H2.25C1.42157 13.75 0.75 13.0653 0.75 12.2206V9.16176M6.75 9.92647L6.75 0.75M6.75 9.92647L3.75 6.86765M6.75 9.92647L9.75 6.86765"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const DownloadIcon = ({
  size = 12,
  className,
}: {
  size?: number;
  className?: string;
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 15"
    fill="none"
    className={className}
    aria-hidden
  >
    <path
      d="M12.75 9.16176V12.2206C12.75 13.0653 12.0784 13.75 11.25 13.75H2.25C1.42157 13.75 0.75 13.0653 0.75 12.2206V9.16176M6.75 9.92647L6.75 0.75M6.75 9.92647L3.75 6.86765M6.75 9.92647L9.75 6.86765"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const RefreshIcon = ({
  size = 12,
  className,
}: {
  size?: number;
  className?: string;
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    className={className}
    aria-hidden
  >
    <path
      d="M10.2 6A4.2 4.2 0 1 1 8.7 2.55"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
    />
    <path
      d="M8.15 1.2h2.3v2.3"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const DeleteIcon = ({
  size = 12,
  className,
}: {
  size?: number;
  className?: string;
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    className={className}
    aria-hidden
  >
    <path
      d="M1.5 3H10.5M4.5 3V2.25C4.5 1.83579 4.83579 1.5 5.25 1.5H6.75C7.16421 1.5 7.5 1.83579 7.5 2.25V3M9 3V9.75C9 10.1642 8.66421 10.5 8.25 10.5H3.75C3.33579 10.5 3 10.1642 3 9.75V3H9Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ImagePlaceholderIcon = ({
  size = 20,
  className,
}: {
  size?: number;
  className?: string;
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    className={className}
    aria-hidden
  >
    <rect
      x="2.5"
      y="4"
      width="15"
      height="12"
      rx="1.5"
      stroke="currentColor"
      strokeWidth="1.2"
    />
    <path
      d="M2.5 13.5L6.75 9.25L9.5 12L13.25 8.25L17.5 12.5V15.5C17.5 16.0523 17.0523 16.5 16.5 16.5H3.5C2.94772 16.5 2.5 16.0523 2.5 15.5V13.5Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinejoin="round"
    />
    <circle cx="7" cy="8" r="1.25" fill="currentColor" />
  </svg>
);

const DocumentIcon = ({
  size = 24,
  className,
}: {
  size?: number;
  className?: string;
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
    aria-hidden
  >
    <path
      d="M21.6045 2.25H7.27875C6.384 3.14325 6.384 7.125 6.384 7.125H22.5V3.14325C22.5 2.24961 21.722 2.24961 21.6045 2.25Z"
      fill="#EE4144"
    />
    <path
      d="M22.5 7.125H6.384V12L14.6858 13.4625L22.5 12V7.125Z"
      fill="#D32B2E"
    />
    <path
      d="M6.384 12V16.875L14.1975 17.85L22.5 16.875V12H6.384Z"
      fill="#BD181B"
    />
    <path
      d="M7.27875 21.75H21.6038C22.5 20.8567 22.5 16.875 22.5 16.875H6.384V20.8567C6.3839 21.7503 7.1613 21.7503 7.27875 21.75Z"
      fill="#911012"
    />
    <path
      d="M4.875 7.125H1.875C1.4625 7.125 1.125 7.4625 1.125 7.875V20.625C1.125 21.0375 1.4625 21.375 1.875 21.375H5.625C6.0375 21.375 6.375 21.0375 6.375 20.625V7.875C6.375 7.4625 6.0375 7.125 5.625 7.125H4.875Z"
      fill="#BD181B"
    />
    <path
      d="M9.75 10.5H17.25M9.75 13.5H17.25M9.75 16.5H14.25"
      stroke="white"
      strokeWidth="1.2"
      strokeLinecap="round"
    />
  </svg>
);

export const FileFieldUploadIcon = memo(UploadIcon);
export const FileFieldDownloadIcon = memo(DownloadIcon);
export const FileFieldRefreshIcon = memo(RefreshIcon);
export const FileFieldDeleteIcon = memo(DeleteIcon);
export const FileFieldDocumentIcon = memo(DocumentIcon);
export const FileFieldImagePlaceholderIcon = memo(ImagePlaceholderIcon);
